export const getTranslations = async (lang) => {
  let language = '';

  switch (lang) {
    case 'es':
      language = 'es_ES';
      break;
    case 'it':
      language = 'it_IT';
      break;
    case 'fr':
      language = 'fr_FR';
      break;
    case 'de':
      language = 'de_DE';
      break;

    default:
      language = 'en';
  }

  return await fetch(`https://spa-translations.siteground.com/birthday_20/${language}.json`)
    .then(async (response) => {
      return await response.json();
    })
    .catch((err) => {
      console.error(err);
    });
};
